/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.32/esri/copyright.txt for details.
*/
import s from"./GPOptions.js";import{constructRequest as e,decode as r}from"./utils.js";import t from"../support/GPMessage.js";async function m(m,o,a,p){return a=s.from(a||{}),e(m,"execute",a,o??{},p).then((async({data:s})=>({results:await Promise.all(s.results?.map(r)??[]),messages:s.messages?.map((s=>t.fromJSON(s)))??[]})))}export{m as execute};
